import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MatIcon} from '@angular/material/icon';
import {FlexPosService} from './core/services/flex-pos.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatIcon
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  private flexPosService = inject(FlexPosService);

  closeBrowser() {
    this.flexPosService.closeBrowser();
  }
}
